import { Button, Tab, Tabs } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Chat from "./Chat/Chat";

function AdminChat(props) {
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <React.Fragment>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Mentee" fullWidth />
          <Tab label="Mentor" fullWidth />
        </Tabs>
      </Box>

      <div value={value} index={0} hidden={value != 0}>
        <Chat room="mentee" />
      </div>

      <div value={value} index={0} hidden={value != 1}>
        <Chat room="mentor" />
      </div>
    </React.Fragment>
  );
}

export default AdminChat;
